import React from 'react'
import ChatbotContainer from '../ChatBot/components/feed'
import withInteractionService from '../common/hoc/withInteractionService'

const AmplifyBot = (props = {}) => {
    const { botname, Interactions, welcomeMessage, sendMessage, ...rest } = props

    return <ChatbotContainer
        {...rest}
        withMessaging
        sendMessage={sendMessage}
        botname={botname}
        Interactions={Interactions}
        welcomeMessage={welcomeMessage} />

}

export default withInteractionService(AmplifyBot)